import clsx from 'clsx'
import {useEffect, useState} from 'react'
import {Form, FormControl, InputGroup, Table} from 'react-bootstrap'
import {
  CreateOfferPackageAmountPlan,
  getOfferPackageAmountPlans,
  updateOfferPackageAmountPlan,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

const SitePricingPlugin = () => {
  const [offerCountPackages, setOfferCountPackages] = useState<any>([])
  const [offerCountPackageName, setOfferCountPackageName] = useState<any>('')
  const [offerCountPackageTotalAmount, setOfferCountPackageTotalAmount] = useState<any>('')
  const [offerCountPackageAmount, setOfferCountPackageAmount] = useState<any>('')
  const [offerCountPackageCount, setOfferCountPackageCount] = useState<any>('')
  const [offerCountPackageMostPopular, setOfferCountPackageMostPopular] = useState<any>(false)
  const [offerCountPackageDescription, setOfferCountPackageDescription] = useState<any>('')

  const [OfferCountPackagesChanges, setOfferCountPackagesChanges] = useState<any>({
    offer_package_id: 0,
    offer_count: 0,
    total_amount: 0,
    amount: 0,
    name: '',
    is_most_popular: false,
    description: '',
  })

  useEffect(() => {
    getOfferAmountPackages()
  }, [])

  const getOfferAmountPackages = async () => {
    let result = await getOfferPackageAmountPlans()
    if (result.success) {
      setOfferCountPackages(result.data)
    }
  }

  const createOfferAmountPackages = async () => {
    let result = await CreateOfferPackageAmountPlan(
      offerCountPackageCount,
      offerCountPackageTotalAmount,
      offerCountPackageAmount,
      offerCountPackageName,
      offerCountPackageMostPopular,
      offerCountPackageDescription
    )
    if (result.success) {
      ToastUtils({type: 'success', message: 'Offer Amount Package is Created'})
      getOfferAmountPackages()
      setOfferCountPackageAmount('')
      setOfferCountPackageTotalAmount('')
      setOfferCountPackageCount('')
      setOfferCountPackageName('')
      setOfferCountPackageMostPopular(false)
      setOfferCountPackageDescription('')
    } else {
      ErrorToastUtils()
    }
  }

  const handleOfferAmountPackagesInputChange = (event: any, index: number) => {
    const {name, value} = event.target
    let updatedCreditAmountPackages = [...offerCountPackages]

    if (name === 'is_most_popular' && event.target.checked) {
      updatedCreditAmountPackages = updatedCreditAmountPackages.map((data) => {
        return {
          ...data,
          is_most_popular: false,
        }
      })
    }

    updatedCreditAmountPackages[index][name] =
      name === 'is_most_popular' ? event.target.checked : value

    setOfferCountPackages(updatedCreditAmountPackages)

    const {
      _id,
      offer_count,
      amount,
      total_amount,
      name: packageName,
      is_most_popular,
    } = updatedCreditAmountPackages[index]

    setOfferCountPackagesChanges({
      offer_package_id: _id,
      offer_count: name === 'offer_count' ? value : offer_count,
      total_amount: name === 'total_amount' ? value : total_amount,
      amount: name === 'amount' ? value : amount,
      name: name === 'name' ? value : packageName,
      is_most_popular: name === 'is_most_popular' ? event.target.checked : is_most_popular,
    })
  }

  const onBlurUpdateOfferAmountPackages = () => {
    updateOfferAmountPackages(
      OfferCountPackagesChanges.offer_package_id,
      OfferCountPackagesChanges.offer_count,
      OfferCountPackagesChanges.total_amount,
      OfferCountPackagesChanges.amount,
      OfferCountPackagesChanges.name,
      OfferCountPackagesChanges.is_most_popular,
      OfferCountPackagesChanges.description
    )
  }

  const updateOfferAmountPackages = async (
    pkgId: any,
    credit: any,
    totalAmount: any,
    amount: any,
    name: any,
    isMostPopular: any,
    description: any
  ) => {
    let result = await updateOfferPackageAmountPlan(
      pkgId,
      credit,
      totalAmount,
      amount,
      name,
      isMostPopular,
      description
    )
    if (result.success) {
      ToastUtils({type: 'success', message: 'Offer Amount Package is Updated'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='row'>
      <div>
        <div className='card'>
          <div className='card-title p-4'>
            <div className='d-flex justify-content-between'>
              <h4 className='mt-4 '>Price in INR to buy Offers</h4>
              <button
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#add_credit_plan'
              >
                Add Plan
              </button>
            </div>
          </div>

          <div className='card-body'>
            <Table striped bordered hover className='mt-5'>
              <thead>
                <tr>
                  <th>Package Name</th>
                  <th>Offer Count</th>
                  <th>Total Price(Inr)</th>
                  <th>Price(Inr)</th>
                  <th>Is Most Popular</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {offerCountPackages.length !== 0 &&
                  offerCountPackages.map((creditAmountPackage: any, index: number) => {
                    return (
                      <tr key={index}>
                        <td>
                          <InputGroup>
                            <FormControl
                              placeholder='Offer Name'
                              name='name'
                              value={creditAmountPackage?.name}
                              onChange={(event) =>
                                handleOfferAmountPackagesInputChange(event, index)
                              }
                              onBlur={onBlurUpdateOfferAmountPackages}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <InputGroup>
                            <FormControl
                              placeholder='Offer Count'
                              name='offer_count'
                              value={creditAmountPackage?.offer_count}
                              onChange={(event) =>
                                handleOfferAmountPackagesInputChange(event, index)
                              }
                              onBlur={onBlurUpdateOfferAmountPackages}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <InputGroup>
                            <FormControl
                              placeholder='Total Amount'
                              name='total_amount'
                              value={creditAmountPackage?.total_amount}
                              onChange={(event) =>
                                handleOfferAmountPackagesInputChange(event, index)
                              }
                              onBlur={onBlurUpdateOfferAmountPackages}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <InputGroup>
                            <FormControl
                              placeholder='Amount'
                              name='amount'
                              value={creditAmountPackage?.amount}
                              onChange={(event) =>
                                handleOfferAmountPackagesInputChange(event, index)
                              }
                              onBlur={onBlurUpdateOfferAmountPackages}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <InputGroup>
                            <Form.Check
                              type='checkbox'
                              name='is_most_popular'
                              checked={creditAmountPackage?.is_most_popular}
                              onChange={(event) =>
                                handleOfferAmountPackagesInputChange(event, index)
                              }
                              onBlur={onBlurUpdateOfferAmountPackages}
                            />
                          </InputGroup>
                        </td>
                        <td>
                          <ReactQuill
                            theme='snow'
                            value={creditAmountPackage.description}
                            onChange={(value) => {
                              let updatedCreditAmountPackages = [...offerCountPackages]

                              updatedCreditAmountPackages[index]['description'] = value

                              setOfferCountPackages(updatedCreditAmountPackages)

                              const {
                                _id,
                                offer_count,
                                amount,
                                total_amount,
                                name: packageName,
                                is_most_popular,
                              } = updatedCreditAmountPackages[index]

                              setOfferCountPackagesChanges({
                                offer_package_id: _id,
                                offer_count: offer_count,
                                total_amount: total_amount,
                                amount: amount,
                                name: packageName,
                                is_most_popular: is_most_popular,
                                description: value,
                              })
                            }}
                            onBlur={onBlurUpdateOfferAmountPackages}
                          />
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      <div className='modal fade' tabIndex={-1} id='add_credit_plan'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Add Offer Count Plan</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='fa-solid fa-xmark'></i>
              </div>
            </div>
            <div className='modal-body'>
              <input
                placeholder='Package Name'
                type='text'
                name='name'
                className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                autoComplete='off'
                value={offerCountPackageName}
                onChange={(e) => setOfferCountPackageName(e.target.value)}
              />
              &nbsp;&nbsp;&nbsp;
              <input
                placeholder='0'
                type='number'
                name='offer_count'
                className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                autoComplete='off'
                value={offerCountPackageCount}
                onChange={(e) => setOfferCountPackageCount(Math.abs(parseInt(e.target.value)))}
              />
              &nbsp;&nbsp;&nbsp;
              <input
                placeholder='Enter Package Total Amount'
                type='number'
                name='total_amount'
                className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                autoComplete='off'
                value={offerCountPackageTotalAmount}
                onChange={(e) =>
                  setOfferCountPackageTotalAmount(Math.abs(parseInt(e.target.value)))
                }
              />
              &nbsp;&nbsp;&nbsp;
              <input
                placeholder='Enter Package Amount'
                type='number'
                name='amount'
                className={clsx('form-control form-control-solid mb-3 mb-lg-0')}
                autoComplete='off'
                value={offerCountPackageAmount}
                onChange={(e) => setOfferCountPackageAmount(Math.abs(parseInt(e.target.value)))}
              />{' '}
              &nbsp;&nbsp;&nbsp;
              <ReactQuill
                theme='snow'
                value={offerCountPackageDescription}
                onChange={(value) => {
                  setOfferCountPackageDescription(value)
                }}
              />
            </div>

            <div className='modal-footer'>
              <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                Close
              </button>
              <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={createOfferAmountPackages}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SitePricingPlugin
